/* global translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ImageSvg from '../image/ImageSvg';

const VerificationError = (props) => {
  const { message, action, adminComment } = props;

  const actionButton = () => {
    if (action === 'activate') {
      return (
        <a href="/auth/resend_code" className="btn btn--b mbm ttu">
          {get(translations, 'txt: Apstiprināt', '')}
        </a>
      );
    }

    if (action === 'images') {
      return (
        <a href="/images" className="btn btn--b mbm">
          {get(translations, 'txt: Mani foto', '')}
        </a>
      );
    }

    return (null);
  };

  const adminCommentText = () => {
    if (adminComment !== '') {
      return (
        <div className="message">
          <div className="flash-inner dib pr twsnw">
            <div className="flash-icon" />
            <div className="flash-content mls">
              {adminComment}
            </div>
          </div>
        </div>
      );
    }

    return (null);
  };

  return (
    <div>
      <div className="mbm">
        <div className="message">
          <div className="flash-inner error dib pr twsnw">
            <div className="flash-icon">
              <ImageSvg svg="icon-warning" iconClass="icon--full icon--warning" />
            </div>
            <div className="flash-content mls">
              {get(translations, message, '')}
            </div>
          </div>
        </div>
        {adminCommentText()}
      </div>
      {actionButton()}
    </div>
  );
};

VerificationError.propTypes = {
  message: PropTypes.string,
  adminComment: PropTypes.string,
  action: PropTypes.string,
};

VerificationError.defaultProps = {
  message: '',
  adminComment: '',
  action: '',
};

export default VerificationError;
